import constants from '../constants/common';

const { DATA_CREATION_SEQUENCE_ATTRIBUTE } = constants;

function calculateCreationSequence(compositionGroupNode) {
  let maxSequence = 0;

  let compositionItem = compositionGroupNode.firstElementChild;

  while (compositionItem) {
    const sequenceAttr = compositionItem.getAttribute(DATA_CREATION_SEQUENCE_ATTRIBUTE);
    const sequence = parseInt(sequenceAttr, 10);

    if (sequence > maxSequence) {
      maxSequence = sequence;
    }

    compositionItem = compositionItem.nextElementSibling;
  }

  return `${maxSequence + 1}`;
}

export default calculateCreationSequence;
